<template>
    <div>
        <div v-if="!jobCompleted">
            <a class="btn-round btn-round--ghost" @click="openModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><g fill="#EF6E0B" stroke="#EF6E0B" stroke-width=".5" fill-rule="evenodd"><path d="M3.47 17.916l-1.299 5.542 5.542-1.299 15.5-15.501a1.501 1.501 0 000-2.121l-2.121-2.121c-.567-.567-1.556-.567-2.122 0l-15.5 15.5zM1.5 24.629a.501.501 0 01-.487-.614l1.516-6.466a.506.506 0 01.133-.239L18.263 1.708c.944-.944 2.591-.944 3.536 0L23.92 3.83c.975.974.975 2.56 0 3.535L8.319 22.966a.509.509 0 01-.239.134l-6.466 1.516a.554.554 0 01-.114.013h0z" /><path d="M22.862 8.222a.507.507 0 01-.354-.146l-4.952-4.953a.5.5 0 01.707-.707l4.953 4.952a.502.502 0 01-.354.854m-1.427 1.426a.501.501 0 01-.355-.147l-4.939-4.965a.5.5 0 11.709-.705l4.94 4.964a.5.5 0 01-.355.853M8.218 22.86a.501.501 0 01-.354-.145l-4.95-4.95a.5.5 0 01.707-.707l4.95 4.949a.5.5 0 01-.353.854" /></g></svg>
                Edit
            </a>
            <NewJobModal ref="modal" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import NewJobModal from '@/jobs/new/Modal';
import { EventBus } from '@/event-bus.js';

export default {
    components: {
        NewJobModal
    },

    data() {
        return {
            loading: true,
            id: this.$root.jobId,
            job: JSON.parse(this.$root.job),
            products: JSON.parse(this.$root.products),
            configuration: JSON.parse(this.$root.configuration),
        }
    },

    computed: {
        jobCompleted() {
            return this.$root.status == 'Complete';
        }
    },

    created() {
        EventBus.$on('update-job-status', (value) => {
            this.populate();
            this.updateField({ field: 'status', value});
            this.updateJob();
        });
    },

    methods: {
        ...mapActions('job', ['populateJob', 'updateField', 'updateJob']),
        ...mapActions('configuration', ['populateConfiguration']),

        populate() {
            this.populateJob({
                id: this.id,
                ...this.job
            });

            this.populateConfiguration({
                products: this.products,
                configuration: this.configuration
            });
        },

        openModal() {
            this.populate();
            this.$refs.modal.open();
        }
    }
};
</script>

<style lang="scss" scoped>
    .flex-1 {
        flex: 1
    }

    .no-results {
        margin-top: 6em;
        text-align: center;
    }

    .search-filter__toggle {
        flex: 0 0 auto;
    }

    .search-filter__section-bottom {
        justify-content: space-between;

        &::after {
            display: none;
        }
    }
</style>
